import { getUserSFId } from './../Utility'
import keycloak from '../../../keycloak'
import { fetchSavedSearches, getPropertyPhotos } from '../../Services/propertySearchService'
// import propertySearchAPIs from '../../../../apis/propertySearchAPIs'
// import APIInterceptor from '../../../../apis/APIInterceptors'

class GetSavedSearch {
    constructor(setSavedLists, setSavedSearch, reloadFlag = true) {
        this.setSavedLists = setSavedLists
        this.setSavedSearch = setSavedSearch
        this.reloadFlag = reloadFlag
    }

    createPayload() {
        // let userDetails = {}
        const user_SFId = getUserSFId()
        // const user_Id = this.keycloak
        let userDetails = {
            'userDetails': {
                omniViewUserId: user_SFId,
                userId: keycloak.subject
            },
            "reloadFlag": this.reloadFlag
        }
        return userDetails
    }

    async fetchSavedSearch() {
        const payload = this.createPayload()
        payload["options"] = ["savedsearch"]
        // const headers = { 'Authorization': `Bearer ${keycloak.token}`, 'Content-Type': 'application/json' }
        // const response = await API.post(propertySearchAPIs.getSavedSearch, payload, { headers })

        const response = await fetchSavedSearches(payload)

        if (response && response.status === 200) {
            let savedSearch = [...response.data.data]

            // sort by lastmodified date desc
            savedSearch = savedSearch.sort(function (a, b) {
                return new Date(b.lastModifiedDate) - new Date(a.lastModifiedDate);
            })

            // Putting Target Market on Top
            const index = savedSearch.findIndex(x => x.isTargetMarket)
            if (index !== -1 && index !== 0) {
                savedSearch.forEach(function (item, i) {
                    if (item.isTargetMarket) {
                        savedSearch.splice(i, 1);
                        savedSearch.unshift(item);
                    }
                })
            }

            savedSearch = [...this.addCustomFields(savedSearch)]

            this.setSavedSearch(savedSearch)
        }

    }

    async fetchSavedLists() {
        const payload = this.createPayload()
        payload["options"] = ["savedlist", "sharedlist"]
        // if (!flag) {
        //     payload["from"] = 0
        //     payload["size"] = 5
        // }

        // const headers = { 'Authorization': `Bearer ${keycloak.token}`, 'Content-Type': 'application/json' }
        // const response = await API.post(propertySearchAPIs.getSavedSearch, payload, { headers })

        const response = await fetchSavedSearches(payload)

        if (response && response.status === 200) {
            let savedLists = [...response.data.data]
            let totalCount = response.data && response.data.data && response.data.total

            // // sort by lastmodified date desc
            savedLists = savedLists.sort(function (a, b) {
                return new Date(b.lastModifiedDate) - new Date(a.lastModifiedDate);
            })

            savedLists = [...this.addCustomFields(savedLists)]

            // this.setSavedLists(savedLists)

            savedLists = await this.getPropertyPhotos(savedLists)

            this.setSavedLists(savedLists)
        }

    }

    async getPropertyPhotos(savedLists) {

        try {

            let propIds = []

            savedLists.slice(0, 4).forEach(item => {
                let subject = item.compsList.filter(x => x.isSubjectProperty)
                if (subject.length > 0) {
                    propIds.push(subject[0].omniViewPropertyId)
                }
            });

            if (propIds.length > 0) {

                let payload = { "query": [{ "whereIn": ["property_code", propIds], "andWhere": ["is_primary_indicator", "1"] }], "properties": ["document_guid", "property_code"], "includes": ["document"] }

                // let url = window.REACT_GLOBAL_CONFIG.Polaris_Photo_API + propertySearchAPIs.queryPhoto

                const photoResponse = await getPropertyPhotos(payload)

                if (photoResponse.data && photoResponse.data.data) {

                    photoResponse.data.data.forEach(item => {

                        savedLists.slice(0, 4).forEach(list => {

                            let index = list.compsList.findIndex(x => x.isSubjectProperty)

                            if (index !== -1 && list.compsList[index].omniViewPropertyId === item.property_code) {
                                list.compsList[index].propPicture = item.signedUrl
                            }

                        });
                    });

                }

            }

        } catch (error) {
            console.log('error in getPropertyPhotos = ', error)
        }

        return savedLists
    }

    addCustomFields(list) {

        list.forEach(item => {
            item.omniViewPropertyListId = item.omniViewPropertyListId ? item.omniViewPropertyListId : ''
            item.polarisPropertySearchCriteriaId = item.polarisPropertySearchCriteriaId ? item.polarisPropertySearchCriteriaId : ''
        })

        return list
    }

    // loadData(response) {
    //     if (response.data && response.data.data) {
    //         let data = response.data.data

    //         this.setSearchResult({ property: data, totalCount: response.data.total })
    //     }
    // }

    // getUserInfo() {
    //     const user_SFId = getUserSFId()
    //     const SearchCriteriaClsObj = new SearchCriteriaCls()
    //     const searchCriteria = SearchCriteriaClsObj.GetSearchCriteria()

    //     if (user_SFId) {
    //         const payload = { "omniViewUserId": user_SFId }

    //         this.keycloak.updateToken()
    //             .success(async () => {
    //                 const response = await APIInterceptor(propertySearchAPIs.getUserInfo, payload, this.keycloak.token)
    //                 console.log('getUserInfo:::', response)
    //                 if (response && response.status === 200) {
    //                     let userInfo = [...response.data.data]
    //                     if (userInfo.length) {
    //                         let subOffice = userInfo.subBranch
    //                         subOffice = subOffice.split('-')

    //                         if (subOffice.length > 1) {
    //                             if (subOffice[0].includes('Housing')) {
    //                                 subOffice = subOffice[1].trim()
    //                             } else {
    //                                 subOffice = subOffice[0].trim()
    //                             }
    //                         } else {
    //                             subOffice = subOffice[0].trim()
    //                         }
    //                         subOffice = subOffice.replace(' MARC', '')
    //                         let state = ''
    //                         if (subOffice.substring(subOffice.length - 3, subOffice.length - 2) == ' ') {
    //                             state = subOffice.substring(subOffice.length - 2)
    //                             subOffice = subOffice.substring(0, subOffice.length - 3)
    //                         }

    //                         //var searchcond = '(Property_County__c = %27' + subOffice + '%27 OR City__c = %27' + subOffice + '%27)';
    //                         let geoLocation = {}
    //                         geoLocation.selectedItem = 'city'
    //                         geoLocation.city = subOffice
    //                         if (state !== '') {
    //                             geoLocation.state = state
    //                         }
    //                         searchCriteria.prospecting.push(geoLocation)

    //                         geoLocation = {}
    //                         geoLocation.selectedItem = 'propertyCounty'
    //                         geoLocation.propertyPropertyCounty = subOffice
    //                         if (state !== '') {
    //                             geoLocation.state = state
    //                         }
    //                         searchCriteria.prospecting.push(geoLocation)

    //                         this.setSearchCriteria(searchCriteria)

    //                         const searchResult = new GetSearchResult(searchCriteria, this.keycloak, function (response, isError) {
    //                             // setShowSpinner(false)
    //                             if (!isError) {
    //                                 this.loadData(response, searchCriteria)
    //                             }
    //                         })
    //                         searchResult.fetchSearchResult()
    //                     }
    //                 }
    //             })
    //             .error(err => {
    //                 console.log('error in getUserInfo : ', err)
    //             })
    //     }

    // }


}

export default GetSavedSearch
